export default function Logo() {
  return <h1 className="primary__heading">Todo</h1>;
}
